import { useNavigate } from 'react-router-dom';
import React, { useState } from "react";
import axios from 'axios';

const BASE_API_URL = process.env.REACT_APP_API_URL;
const API_URL = `${BASE_API_URL}/ChangePassword`;

export default function ChangePassword({ isOpen, onClose }) {
    const [countdown, setCountdown] = useState(5);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordErrors, setPasswordErrors] = useState({
        password: '',
        confirmPassword: '',
    });
    const [showAfterFP, setShowAfterFP] = useState(false);
    const navigate = useNavigate();
    const validatePassword = () => {
        let valid = true;
        const newErrors = {
            password: '',
            confirmPassword: '',
        };

        if (!password) {
            newErrors.password = 'Password is required';
            valid = false;
        } else if (password.length < 6) {
            newErrors.password = 'Password should contain minimum 6 characters';
            valid = false;
        }

        if (!confirmPassword) {
            newErrors.confirmPassword = 'Confirm Password is required';
            valid = false;
        } else if (confirmPassword !== password) {
            newErrors.confirmPassword = 'Confirm Password does not match';
            valid = false;
        }

        setPasswordErrors({ ...newErrors });
        return valid;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'password') {
            setPassword(value);
            setPasswordErrors((prevErrors) => ({
                ...prevErrors,
                password: '',
            }));
        } else if (name === 'confirmPassword') {
            setConfirmPassword(value);
            setPasswordErrors((prevErrors) => ({
                ...prevErrors,
                confirmPassword: '',
            }));
        }
    };

    const userDetails = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
    const token = localStorage.getItem('token');

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const handleSubmit = () => {
        if (validatePassword()) {
            axios.post(`${API_URL}`, {
                "UserId": userDetails.UserId,
                "Password": password,
                "ConfirmPassword": confirmPassword
            }, config
            ).then(response => {
                console.log(response);
                if (response.data.Succeeded) {
                    setShowAfterFP(true);
                    let timeLeft = 5;
                    setCountdown(timeLeft);
                    const timer = setInterval(() => {
                        timeLeft -= 1;
                        setCountdown(timeLeft);

                        if (timeLeft === 0) {
                            clearInterval(timer);
                            // logout if required:
                            localStorage.clear();
                            // redirect
                            navigate('/login');
                        }
                    }, 1000);
                }
                else {
                    const newErrors = {
                        password: '',
                        confirmPassword: '',
                    };

                    newErrors.password = response.data.Errors[0];
                    setPasswordErrors({ ...newErrors });
                }
            });

        }
    };

    return (
        <>
            <div className={`modal fade ${isOpen ? 'show d-block' : ''}`} style={{ background: '#0000006e', backdropFilter: 'none' }}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="head">Change Password</h4>
                        </div>
                        <div className="modal-body">
                            {!showAfterFP ? (<>
                                <form className="mb-40">
                                    <div className="form-group text-left">
                                        <input
                                            value={password}
                                            type="password"
                                            className="form-control mb-0"
                                            placeholder="New Password"
                                            id="password"
                                            name="password"
                                            autoComplete="off"
                                            onChange={handleChange}
                                        />
                                        {passwordErrors.password && <p className="error-message red">{passwordErrors.password}</p>}
                                    </div>
                                    <div className="form-group text-left">
                                        <input
                                            value={confirmPassword}
                                            type="password"
                                            className="form-control mb-0"
                                            placeholder="Confirm Password"
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            autoComplete="off"
                                            onChange={handleChange}
                                        />
                                        {passwordErrors.confirmPassword && <p className="error-message red">{passwordErrors.confirmPassword}</p>}
                                    </div>
                                </form>
                            </>
                            ) : (
                                <>
                                        <div className="text-center">
                                            <h4>Your password has been reset successfully.</h4>
                                            <p>You will be logged out from this session.</p>
                                            <p>Please log in again using your new password.</p>

                                            <h5 className="mt-3">Redirecting in {countdown} seconds...</h5>
                                        </div>
                                </>
                            )}
                        </div>
                        <div className={!showAfterFP ? 'modal-footer' : 'modal-footer hide'}>
                            <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                                Change Password
                            </button>
                            <button type="button" className="btn btn-outline" onClick={onClose}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

